import { useClientPortalSubmit, APIError, defaultParseError } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../../../hooks/useUser";
import { useFetchCobranding } from "./useFetchCobranding";

export function useSavePrimaryColor() {
  const { t } = useTranslation();
  const { mutate: refreshUser } = useUser();
  const { mutate: refetchCobranding } = useFetchCobranding();

  const { submit, isSubmitting, response } = useClientPortalSubmit(
    "/api/internal/client-portal/customer-accounts/cobranding-colors/",
    {
      onSuccess: () => {
        showToast(t("Primary color updated successfully"));
        refreshUser();
        refetchCobranding();
      },
      onFailure: (error) => {
        let errorMessage = t(
          "Failed to update primary color. Please try again."
        );

        if (error instanceof APIError) {
          const apiErrorMessage = defaultParseError(error);
          if (apiErrorMessage) {
            errorMessage = apiErrorMessage;
          }
        }

        showToast(`${t("Error")}: ${errorMessage}`, {
          type: "error",
        });
      },
    }
  );

  const savePrimaryColor = async (color: string, optimalTextColor: string) => {
    return await submit({
      org_primary_color: color,
      optimal_text_color: optimalTextColor,
    });
  };

  return {
    savePrimaryColor,
    isSubmitting,
    response,
  };
}
